<template lang="pug">
.filters
    b-form-select.margin(
      v-if="userRole"
      v-model="filters.tecnico"
      :options="technicianOptions"
      :disabled="loading"
    )

    b-icon.margin(
      icon="x-circle"
      font-scale="1.5"
      variant="primary"
      style="cursor: pointer;"
      title="Eliminar filtros"
      v-if="filters.tecnico"
      @click="removeFilters"
    )

    DownloadOTS.mb-3.mr-2.mb-lg-0(:otsFiltered="otsFiltered")
    RefreshData(@refreshDashboard="onRefreshDashboard")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DownloadOTS from '@/components/UI/DownloadOTs.vue'
import RefreshData from '@/components/Dashboard/RefreshData.vue'
import { applyDashboardFilters } from '@/store/OT/actions'
import { mapState, mapWritableState } from 'pinia'
import { useDashboardStore } from '../../pinia/views/useDashboardStore'

export default {
  name: 'Filters',
  props: ['otsFiltered'],
  components: { DownloadOTS, RefreshData },
  data() {
    return {
      userRole: null,
      serviceTypeOptions: [
        { value: null, text: 'Filtros por garantía' },
        { value: 1, text: 'Garantía' },
        // { value: 2, text: 'Garantía on Site 5D' },
        // { value: 3, text: 'Garantía on Site 7x24' },
        { value: 4, text: 'Presupuesto' },
      ],
    }
  },

  async created() {
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.userRole = user.groups.find(
      (r) =>
        r.name === 'Gerencia' ||
        r.name === 'Administrativo' ||
        r.name === 'Supervisor'
    )
    await this.listTechnicians()
  },

  methods: {
    ...mapActions('TechniciansStore', ['listTechnicians']),
    ...mapActions('OT', ['getDashboard']),

    async removeFilters() {
      this.filters.tecnico = null
    },

    async onRefreshDashboard() {
      this.loading = true
      const filters = { ...this.queryParams, refresh: true }
      const r = await this.getDashboard(filters)
      this.$emit('filterData', r.data.ots)
      this.$emit('last_update', r.data.last_update)
      this.loading = false
    },

    onFiltersChange() {
      // El dashboard completo ya está en memoria (cachedDashboardOTS, que se
      // mantiene al día con cada fetch inicial o evento de websocket) — un
      // cambio de filtro es una operación local instantánea, sin red. Antes
      // getDashboard() evitaba la red sólo si ese cache estaba tibio; ahora
      // siempre golpea la red (SILL-1470), así que hay que filtrar acá
      // directamente para no perder la instantaneidad.
      this.$emit(
        'filterData',
        applyDashboardFilters(this.cachedDashboardOts, this.queryParams)
      )
    },
  },

  computed: {
    ...mapGetters('TechniciansStore', ['technicians']),
    ...mapGetters('OT', ['cachedDashboardOts']),
    ...mapWritableState(useDashboardStore, ['filters', 'loading']),
    ...mapState(useDashboardStore, ['queryParams']),

    technicianOptions() {
      let availableTechnicians = this.technicians.filter(t => t.cantidad_ot_garantia > 0 || t.cantidad_ot_presupuesto > 0)

      // Filtrar por tipo de servicio
      if (this.filters.tipoServicio === 4) {
        // Presupuesto: mostrar solo técnicos con capacidad para presupuestos
        availableTechnicians = availableTechnicians.filter(t => t.cantidad_maxima_presupuesto > 0)
      } else if (this.filters.tipoServicio === 1) {
        // Garantía: mostrar solo técnicos con capacidad para garantías
        availableTechnicians = availableTechnicians.filter(t => t.cantidad_maxima > 0)
      }

      const mappedTechnicians = availableTechnicians.map((t) => {
        const names = `${t.tecnico.first_name} ${t.tecnico.last_name}`
        const garantia = `${Number(t.cantidad_ot_garantia) || 0}/${Number(t.cantidad_maxima) || 0}G`
        const presupuesto = `${t.cantidad_ot_presupuesto || 0}/${t.cantidad_maxima_presupuesto || 0}P`
        const total = `${(t.cantidad_ot_garantia || 0) + (t.cantidad_ot_presupuesto || 0)}/${(t.cantidad_maxima_total || 0)}T`



        return {
          value: t.tecnico.id,
          text: `${names} (${garantia}) (${presupuesto}) (${total})`,
        }
      }).sort((a, b) => a.text.localeCompare(b.text))

      mappedTechnicians.unshift({
        value: null,
        text: 'Todos',
      })
      mappedTechnicians.unshift({
        value: null,
        text: 'Filtros por técnico',
        disabled: true,
      })

      return mappedTechnicians
    },



    watchedFilters() {
      const f = this.filters
      return [f.tipoServicio, f.tipoCliente, f.tecnico, f.on_site]
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.onFiltersChange()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.margin {
  &:not(:last-child) {
    margin-right: 15px;
  }

  @include media-breakpoint-down(md) {
    margin-bottom: 10px;
  }
}

.filters {
  display: flex;

  @include media-breakpoint-down(md) {
    display: block;
  }
}
</style>
